import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowseCategoryModule} from './browse-category/browse-category.module';
import {BrowseIndustryModule} from './browse-industry/browse-industry.module';
import {PopularAppsModule} from './popular-apps/popular-apps.module';
import {RecentlyAddedModule} from './recently-added/recently-added.module';
import {HomepageErrorModule} from '@app/homepage/homepage-error/homepage-error.module';

@NgModule({
  imports: [
    CommonModule,
    BrowseCategoryModule,
    BrowseIndustryModule,
    PopularAppsModule,
    RecentlyAddedModule,
    HomepageErrorModule,
  ],
  declarations: [],
  exports: [
    BrowseCategoryModule,
    BrowseIndustryModule,
    PopularAppsModule,
    RecentlyAddedModule,
    HomepageErrorModule,
  ]
})
export class HomepageModule {
}
